import { useRef, useState } from 'react';

import type { KeyLabelObj } from '@/chat-types/common';
import * as SC from '@/components/login/LanguageSelect.style';
import useOutsideClick from '@/hooks/useOutsideClick';
import type { LanguageCodes } from '@/i18n';
import strings, { languageName } from '@/i18n';
import useLanguageCode from '@/stores/languageCodeStore';

const LanguageSelect = () => {
  const languageCodeStore = useLanguageCode();
  const languages = strings.getAvailableLanguages().map((lang) => {
    return { key: lang, label: languageName(lang) };
  }) as Array<KeyLabelObj<LanguageCodes, string>>;

  const animationRef = useRef(null);

  const [isOpened, setIsOpened] = useState(false);

  const onOpen = () => {
    setIsOpened((prev) => !prev);
  };

  useOutsideClick({
    selector: '.menu-list',
    onClickOutside: () => {
      setIsOpened(false);
    },
  });

  const onClickItem = (item: KeyLabelObj<LanguageCodes, string>) => {
    onOpen();
    languageCodeStore.changeLanguageCode(item.key);
  };

  return (
    <SC.Container>
      <SC.SelectedButton
        onClick={() => {
          onOpen();
        }}
        className='menu-list'
      >
        <SC.SelectedText>{languageName(languageCodeStore.code)}</SC.SelectedText>
        <SC.Arrow />
      </SC.SelectedButton>
      {isOpened && (
        <SC.MenuList
          onClick={(e) => {
            e.stopPropagation();
          }}
          itemsCount={languages.length}
          ref={animationRef}
          className='menu-list'
        >
          {languages.map((item) => (
            <SC.MenuItem key={item.key} onClick={() => onClickItem(item)}>
              {item.label}
            </SC.MenuItem>
          ))}
        </SC.MenuList>
      )}
    </SC.Container>
  );
};

export default LanguageSelect;
